// ── MessagingTriageClaudePanel (Evo Brain) ───────────────────────────────────
// No renderiza UI propia — el shell vive en AssistantDock. Mismo patrón que
// HomeClaudePanel: sin entidad propia (es una cola sobre `channels`, no un
// registro con id), module 'contacts' (ver entityTypeToModule en service.ts)
// — reusa las tools DM_TOOLS ya existentes (todas requiresEntity:false),
// nada nuevo que construir en el backend.
import { useTranslation } from 'react-i18next';
import { useAssistantModule, useRegisterAssistantActive } from '../../contexts/AssistantContext.js';

export function MessagingTriageClaudePanel() {
  const { t } = useTranslation();

  useAssistantModule('dm_triage', null, undefined);
  useRegisterAssistantActive('dm_triage', null, {
    title: t('dmTriage.assistant.title'),
    placeholder: t('dmTriage.assistant.placeholder'),
    emptyHint: t('dmTriage.assistant.empty'),
  });

  return null;
}
